// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import { TitleH3 } from 'components/Common/Typography'
import Router, { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { Col, Form, Row, Spinner } from 'react-bootstrap'
import { Controller, SubmitHandler, useForm } from 'react-hook-form'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'
import Button from 'components/Button'

type FormValues = {
  yourName: string
  yourEmail: string
  phoneInput?: any | undefined
  skypeID: string
  projectRequirements: string
  service: string
  file: (string | Blob)[]
  name: (string | Blob)[]
  files: (string | Blob)[]
}
interface CaptchaDetails {
  firstValue?: number
  secondValue?: number
  ans?: number
  isCaptchaMatched?: boolean
}

function ContactForm() {
  const [captchaDetails, setCaptchaDetails] = useState<CaptchaDetails>({})
  const schema = yup.object().shape({
    yourName: yup.string().max(80).trim().required('Your Name is required'),
    yourEmail: yup
      .string()
      .email('Invalid email format')
      .max(255)
      .required('Your Email is required'),
    projectRequirements: yup
      .string()
      .trim()
      .required('Your Project Requirements is required'),
    phoneInput: yup
      .string()
      .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
        value ? isValidPhoneNumber(value) : true
      ),
    file: yup
      .mixed()
      .test((value) => {
        return value.length > 0 ? value && value.length : true
      })
      .test('fileSize', 'Max 10MB Allowed', (value) => {
        return value.length > 0
          ? value && value[0] && value[0].size <= 10000000
          : true
      })
      .test(
        'type',
        'Only the following formats are accepted: .jpeg, .jpg, .png, .txt, .ppt, xls, .pdf, .doc and .docx',
        (value) => {
          return value.length > 0
            ? (value && value[0] && value[0].type === 'image/jpeg') ||
                (value && value[0] && value[0].type === 'image/jpg') ||
                (value && value[0] && value[0].type === 'image/png') ||
                (value && value[0] && value[0].type === 'application/pdf') ||
                (value &&
                  value[0] &&
                  value[0].type ===
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
                (value && value[0] && value[0].type === 'application/msword') ||
                (value && value[0] && value[0].type === 'text/plain') ||
                (value &&
                  value[0] &&
                  value[0].type === 'application/vnd.ms-powerpoint') ||
                (value &&
                  value[0] &&
                  value[0].type === 'application/vnd.ms-excel')
            : true
        }
      ),
    // solution: yup
    //   .string()
    //   .required('Captcha is required')
    //   .test('solution', 'Incorrect solution to math sum', (value: string) => {
    //     const solution = parseInt(value, 10)
    //     return solution === captchaDetails.ans
    //   }),
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  })

  const [SuccessMesg, setSuccessMesg] = useState('')
  const [ErrorMesg, setErrorMesg] = useState('')
  const [fileName, setFileName] = useState('')
  const [fileUrlPath, setFileUrlPath] = useState('')
  const [Loading, setLoading] = useState(false)
  const [phoneCountryCode, setPhoneCountryCode] = useState()
  const [formCountryName, setFromCountryName] = useState()

  const router = useRouter()
  const PageUrl = router.query.path
    ? router.query.path
    : router.pathname.split('/')[1]
  const PageUrlCheck = router.query.path === 'get-quote'

  const onSubmit: SubmitHandler<FormValues> = async (dataFetch) => {
    setLoading(true)
    setSuccessMesg('')
    setErrorMesg('')
    setFileName('')

    const formData = new FormData()

    const fileUrlSource = fileUrlPath
    const newComment = {
      name: dataFetch.yourName,
      email: dataFetch.yourEmail,
      skypeId: dataFetch.skypeID,
      services: dataFetch.service.toString(),
      contactNumber: dataFetch.phoneInput,
      pro_requirements: dataFetch.projectRequirements,
      pageName: PageUrl,
      countryName: formCountryName,
      uploadFile: '',
    }
    if (fileUrlSource) {
      formData.append('quoteFile', fileUrlSource)
      const { data } = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/api/user/quote/fileUploadQuote`,
        formData,
        {
          headers: {
            web_id: 'webcluesinfotech',
          },
        }
      )

      const objnew = {
        newComment: 'uploadFile',
      }
      newComment.uploadFile = data?.data
    }

    try {
      const result = await axios.post(
        `${process.env.NEXT_PUBLIC_API_URL}/api/user/quote/sendQuoteInquiry`,
        newComment,
        {
          headers: {
            web_id: 'webcluesinfotech',
          },
        }
      )

      if (result.data.code === 200) {
        setLoading(false)
        setSuccessMesg('Thank you for your message. It has been sent.')
        setTimeout(() => {
          Router.push('/thank-you-1')
        }, 100)
      } else {
        setLoading(false)
        const objres = {
          result: 'message',
        }
        setErrorMesg(objres.result)
      }
    } catch (error) {
      setLoading(false)
      setErrorMesg('Please try again after sometime')
    }
  }
  const serviceList = [
    'Website',
    'Mobile Apps',
    'Hire Dedicated Resources',
    'Others',
  ]
  const handleUpload = (e) => {
    setFileName(e.target.files[0]?.name)
    setFileUrlPath(e.target.files[0] ? e.target.files[0] : '')
  }

  const fetchIpLocation = () => {
    ;(async () => {
      await axios.get(`https://ipapi.co/json/`).then((response) => {
        setPhoneCountryCode(response.data.country_code)
        setFromCountryName(response.data.country_name)
      })
    })()
  }

  useEffect(() => {
    fetchIpLocation()
  }, [])

  return (
    <React.Fragment key="getquote">
      <section className="contactus_section_Dark ">
        <Row className="justify-content-start">
          <TitleH3
            className="mt-4 mt-lg-3 b-2 text_black"
            text="Get In touch with us today"
          />
          <Col xl={12} className="form_block get_quote_frm_main">
            <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
              <div className="d-flex" />
              <Row>
                <Col xl={12} className="mb-2">
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Your Name *"
                      className="bg-transparent"
                      {...register('yourName')}
                    />
                    <p className="alert-error">
                      {errors.yourName && (
                        <span>{errors.yourName.message}</span>
                      )}
                    </p>
                  </Form.Group>
                </Col>
                <Col xl={12} className="mb-2">
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Your Email *"
                      className="bg-transparent"
                      {...register('yourEmail')}
                    />
                    <p className="alert-error">
                      {errors.yourEmail && (
                        <span>{errors.yourEmail.message}</span>
                      )}
                    </p>
                  </Form.Group>
                </Col>
                <Col xl={12} className="mb-2">
                  <Form.Group className="mb-3 bg-transparent">
                    <Controller
                      name="phoneInput"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <PhoneInput
                          value={value}
                          onChange={(e: any) => onChange(e)}
                          defaultCountry={phoneCountryCode}
                          id="phoneInput"
                          className="form-control d-flex border-disable bg-transparent"
                          placeholder="Contact Number"
                        />
                      )}
                    />
                    <p className="alert-error">
                      {errors.phoneInput && (
                        <span>{errors.phoneInput.message}</span>
                      )}
                    </p>
                  </Form.Group>
                </Col>
                <Col xl={12} className="mb-2">
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Skype ID"
                      className="bg-transparent"
                      {...register('skypeID')}
                    />
                  </Form.Group>
                </Col>
                <Col xl={12} className="mt-2">
                  <div className="d-flex pb-2 ss_wrap">
                    <span className="sgaphic_font fw-400 pe-lg-3 ss_lbl">
                      Select Service
                    </span>
                    <div className="d-flex ss_checkbox_wrap">
                      {serviceList.map((c, i) => (
                        <div className="form-check" key={i}>
                          <label
                            key={c}
                            className="pe-lg-1 form-check-label"
                            htmlFor={c}
                          >
                            <input
                              type="checkbox"
                              value={c}
                              className="form-check-input"
                              id={c}
                              {...register('service')}
                            />
                            {c}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
                <Col xl={12} className="mb-2 pt-3">
                  <Form.Control
                    as="textarea"
                    className="py-0 border-disable bg-transparent"
                    placeholder="Project Requirements *"
                    {...register('projectRequirements')}
                    rows={4}
                  />
                  <p className="alert-error">
                    {errors.projectRequirements && (
                      <span>{errors.projectRequirements.message}</span>
                    )}
                  </p>
                </Col>
                <Col xl={12} className="mb-2 pt-2">
                  <div className="choose-file-text">
                    <label htmlFor="file" className="btn-2 choose-file-image">
                      <input
                        {...register('file')}
                        type="file"
                        id="file"
                        onChange={handleUpload}
                        name="file"
                      />

                      {!fileName && <span>Select or Drop your file here</span>}
                      {fileName}
                    </label>
                  </div>
                  <p className="alert-error">
                    {errors.file && <span>{errors.file.message}</span>}
                  </p>
                </Col>
                <Col xl={12} className="mt-2">
                  {Loading && (
                    <Button>
                     Send Request
                    </Button>
                  )}
                  {!Loading && (
                    <Button className="btn-black" type="submit">
                      Send Request
                    </Button>
                  )}
                  {PageUrlCheck && Loading && (
                    <Spinner
                      className="ms-3"
                      animation="border"
                      variant="light"
                      role="status"
                      size="sm"
                    />
                  )}
                  {!PageUrlCheck && Loading && (
                    <Spinner
                      className="ms-3"
                      animation="border"
                      variant="secondary"
                      role="status"
                      size="sm"
                    />
                  )}
                </Col>
                <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-successfully">
                  {SuccessMesg}
                </p>
                <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-error">
                  {ErrorMesg}
                </p>
              </Row>
            </form>
          </Col>
        </Row>
      </section>
    </React.Fragment>
  )
}
export default ContactForm
